var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"magazine-frontpage"},[(_vm.page)?[_c('WpContent',{attrs:{"html":_vm.page.content}})]:_c('LoadingIndicator',{staticClass:"magazine-frontpage__loading"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }